/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useFormContext, useWatch, type FieldPath, type FieldPathValue } from "react-hook-form";
import type { MomentFormMoment } from "../types/moment-form-moment";

export function useMomentFormValues<TFieldPath extends FieldPath<MomentFormMoment>>(
  paths: TFieldPath[],
) {
  const { getValues, control } = useFormContext<MomentFormMoment>();

  // Subscribe to changes
  useWatch({ control, name: paths });

  // getValues returns the values in the same order as the paths array
  const valuesArray = getValues(paths);

  // Use a Record to build the object safely
  const result = {} as Record<TFieldPath, unknown>;

  paths.forEach((path, index) => {
    result[path] = valuesArray[index];
  });

  // Cast once to the final mapped type
  return result as {
    [P in TFieldPath]: FieldPathValue<MomentFormMoment, P>;
  };
}
